import styled from 'styled-components';
import { BASIC_COLOR, BLACK_COLOR, SECONDARY_COLOR } from '../../styles/variables';

export const BatchInfo = styled.div`
  position: relative;
  height: 100%;
  border-radius: 24px;
  display: flex;
  .filtersInfo {
    position: absolute;
    left: 0;
    height: 100%;
    width: 300px;
    z-index: 1;
    background: ${SECONDARY_COLOR};
    padding-left: 60px !important;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 20px;
    overflow-y: scroll;
    transform: ${props => (props.filterSection ? 'translateX(0)' : 'translateX(-100%)')};
    transition: transform 600ms ease;
    box-shadow: rgb(0 0 0 / 36%) 4px 4px 14px;
    ::-webkit-scrollbar {
      display: none;
    }
    .ant-collapse {
      height: auto !important;
      background: ${SECONDARY_COLOR};
      margin-bottom: 24px;
      border: 0;
      overflow: hidden;
    }
  }
  .filtersButton {
    position: absolute;
    left: 0;
    z-index: 2;
    height: 100%;
    width: 50px;
    background: ${BASIC_COLOR};
    color: ${BLACK_COLOR};
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-align: center;
    width: 50px;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    svg {
      transform: ${props => (props.filterSection ? 'rotate(0deg)' : 'rotate(180deg)')};
      transition: transform 300ms ease;
      cursor: pointer;
    }
  }
`;

export const DateFilter = styled.div`
  width: 100%;
  max-height: 40%;
  border-radius: 20px;
  margin: 2px;
  .anticon {
    vertical-align: ${props => props.isTag && '-6px !important'};
  }
  .anticon svg {
    font-size: 18px;
    margin-top: 5px;
    margin-right: 5px;
    color: ${BLACK_COLOR};
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: ${BLACK_COLOR};
    font-size: 12px;
  }
`;

export const FilterTitle = styled.span`
  color: ${BLACK_COLOR};
  font-size: 13px;
  line-height: 28px;
  vertical-align: baseline;
  letter-spacing: normal;
  word-spacing: 0px;
  margin: 0px;
  padding: 0px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
`;

export const FilterData = styled.div`
  color: ${BLACK_COLOR};
  font-size: 12px;
  line-height: 28px;
  font-weight: 600;
  border-bottom: 1px solid ${BLACK_COLOR};
  padding-bottom: 4px;
`;

export const TagsData = styled.div`
  color: #959393;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 10px;
  row-gap: 10px;
  flex-wrap: wrap;
  padding: 2px;
`;

export const Tags = styled.span`
  border: ${props => (props.tableTags ? '2px dotted #50BE77' : '2px dotted #ECF5CE')};
  text-align: center;
  border-radius: 10px;
  background: transparent;
  color: ${props => (props.tableTags ? '#50BE77' : '#ECF5CE')};
  padding: 4px;
  font-weight: 600;
`;
